module.exports = __webpack_public_path__ + "img/b373288.png";